import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { IconButton } from '@atlaskit/button/new';
import ArrowLeftIcon from '@atlaskit/icon/core/arrow-left';
import ArrowRightIcon from '@atlaskit/icon/core/arrow-right';
import { Box, Inline, Stack, Text, xcss } from '@atlaskit/primitives';
var isScrollAtLeft = function isScrollAtLeft(elem) {
  return (elem === null || elem === void 0 ? void 0 : elem.scrollLeft) === 0;
};
var isScrollAtRight = function isScrollAtRight(elem) {
  return elem ? Math.abs((elem === null || elem === void 0 ? void 0 : elem.scrollWidth) - (elem === null || elem === void 0 ? void 0 : elem.scrollLeft) - (elem === null || elem === void 0 ? void 0 : elem.clientWidth)) <= 1 : false;
};
var scrollContainerStyle = xcss({
  display: 'flex',
  overflowX: 'auto',
  scrollbarWidth: 'none',
  whiteSpace: 'nowrap'
});
export var KnowledgeCarousel = function KnowledgeCarousel(_ref) {
  var children = _ref.children,
    headingText = _ref.headingText,
    scrollOffset = _ref.scrollOffset;
  var scrollContainerRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    shouldHideLeft = _useState2[0],
    setShouldHideLeft = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    shouldHideRight = _useState4[0],
    setShouldHideRight = _useState4[1];
  useEffect(function () {
    setShouldHideLeft(isScrollAtLeft(scrollContainerRef.current));
    setShouldHideRight(isScrollAtRight(scrollContainerRef.current));
  }, []);
  var _useDebouncedCallback = useDebouncedCallback(function () {
      setShouldHideLeft(isScrollAtLeft(scrollContainerRef.current));
      setShouldHideRight(isScrollAtRight(scrollContainerRef.current));
    }, 10),
    _useDebouncedCallback2 = _slicedToArray(_useDebouncedCallback, 1),
    onScroll = _useDebouncedCallback2[0];
  var scrollLeft = function scrollLeft() {
    var _scrollContainerRef$c;
    (_scrollContainerRef$c = scrollContainerRef.current) === null || _scrollContainerRef$c === void 0 || _scrollContainerRef$c.scrollBy({
      top: 0,
      left: -scrollOffset,
      behavior: 'smooth'
    });
  };
  var scrollRight = function scrollRight() {
    var _scrollContainerRef$c2;
    (_scrollContainerRef$c2 = scrollContainerRef.current) === null || _scrollContainerRef$c2 === void 0 || _scrollContainerRef$c2.scrollBy({
      top: 0,
      left: scrollOffset,
      behavior: 'smooth'
    });
  };
  return /*#__PURE__*/React.createElement(Stack, {
    space: "space.100"
  }, /*#__PURE__*/React.createElement(Inline, {
    spread: "space-between",
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "large",
    weight: "semibold"
  }, headingText), /*#__PURE__*/React.createElement(Inline, {
    space: "space.050"
  }, !shouldHideLeft && /*#__PURE__*/React.createElement(IconButton, {
    shape: "circle",
    appearance: "subtle",
    icon: ArrowLeftIcon,
    isTooltipDisabled: true,
    label: "",
    onClick: scrollLeft,
    spacing: "compact"
  }), !shouldHideRight && /*#__PURE__*/React.createElement(IconButton, {
    shape: "circle",
    appearance: "subtle",
    icon: ArrowRightIcon,
    isTooltipDisabled: true,
    label: "",
    onClick: scrollRight,
    spacing: "compact"
  }))), /*#__PURE__*/React.createElement(Box, {
    ref: scrollContainerRef,
    onScroll: onScroll,
    xcss: scrollContainerStyle
  }, children));
};